import store from '@/store';

const redirect = (url) => {
  window.location.href = url;
};

const openPaymentWidget = async (widgetData) => {
  const { service, paymentObject } = widgetData;
  await store.dispatch('scriptLoader/loadScript', service);

  return new Promise((resolve, reject) => {
    switch (service) {
      case 'cloudpayments': {
        const language = 'ru-RU';
        const widget = new window.cp.CloudPayments({ language });
        widget.pay('charge', paymentObject, {
          onSuccess: () => {
            resolve({ paymentSuccess: true });
          },
          onFail: () => {
            resolve({ paymentSuccess: false });
          },
        });
        break;
      }
      case 'tiptoppay': {
        const language = 'ru-RU';
        const widget = new window.tiptop.Widget({ language });
        widget.pay('charge', paymentObject, {
          onSuccess: () => {
            resolve({ paymentSuccess: true });
          },
          onFail: () => {
            resolve({ paymentSuccess: false });
          },
        });
        break;
      }
      default:
        reject(new Error('wrong service name'));
        break;
    }
  });
};

/**
 * Запускает процесс оплаты. Выполняет необходимое дествие.
 * @param data.paymentProcessType - Действие для перехода к оплате.
 * @param data.directUrl - Url для редиректа.
 * @param data.widgetData - Данные для открытия виджета.
 * @returns {Promise<boolean>}
 */
const initPaymentProcess = async (data = {}) => {
  const {
    paymentProcessType,
    directUrl: redirectUrl,
    widgetData,
  } = data;

  if (paymentProcessType === 'redirect' && redirectUrl) {
    redirect(redirectUrl);
    return false;
  }
  if (paymentProcessType === 'widget' && widgetData) {
    const { paymentSuccess } = await openPaymentWidget(widgetData);
    return paymentSuccess;
  }
  // Если значение none - ничего делать для оплаты не нужно, соответственно возвращаем true.
  // При других значениях возвращаем false.
  return paymentProcessType === 'none';
};

export default initPaymentProcess;
